import React from "react";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { SettingsAccountVerificationContextImport } from "../../../../../provider/settings/security/account_verification/SettingsAccountVerificationContextProvider";

const SettingsAccountVericationButtons = (props: {
  type?: number | undefined;
}) => {
  const { resendVerification } = SettingsAccountVerificationContextImport();

  return (
    <Col xs={12} sm={10} md={8} className="mx-auto">
      <div
        role="button"
        onClick={() => resendVerification()}
        className="text-center font-size-16_17"
      >
        <span className="font-gotham-bold color-theme-label">
          {AppTranslation.text("didnt_receive_code")}
        </span>
        <span className="mx-2">/</span>
        <span className="font-gotham-book color-theme-sublabel">
          {AppTranslation.text("resend")}
        </span>
      </div>
    </Col>
  );
};

export default SettingsAccountVericationButtons;
